import { render } from "./ResetPassword.vue?vue&type=template&id=0d581b48&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=0d581b48&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/JBN/mi-stock-jbn-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d581b48"]])

export default __exports__